import { isNil } from 'ramda'

import { STORAGE_INSTITUTION, STORAGE_SELECTED_INSTITUTION } from '../constants/storage'

/**
 ** Web Storage stringifies whatever it is given, so a value written while it was
 ** undefined/null reads back as the literal 'undefined'/'null' — JSON.parse then throws
 ** and the getter silently degrades to null, which travels on as an empty request header.
 */
const isStoredValue = value => !isNil(value) && value !== '' && value !== 'undefined' && value !== 'null'

export const getInstitution = () => {
  try {
    const institution = localStorage.getItem(STORAGE_INSTITUTION)
    if (isStoredValue(institution)) {
      return JSON.parse(institution)
    }
  } catch (e) {
    console.error('Error with institution info: ', e)
  }
  return null
}

export const getSelectedInstitution = () => {
  try {
    const selectedInstitution = localStorage.getItem(STORAGE_SELECTED_INSTITUTION)
    if (isStoredValue(selectedInstitution)) {
      return JSON.parse(selectedInstitution)
    }
  } catch (e) {
    console.error('Error in getting selected institution: ', e)
  }
  return null
}

export const setInstitutionId = id => {
  // ** Keep the current institution rather than overwriting it with a blank one
  if (isNil(id)) return

  localStorage.setItem(STORAGE_INSTITUTION, id)
}

export const setSelectedInstitution = institution => {
  // ** JSON.stringify(undefined) returns undefined, not a string — never store that
  if (!isStoredValue(institution)) return

  localStorage.setItem(STORAGE_SELECTED_INSTITUTION, institution)
}

export const removeInstitution = () => {
  localStorage.removeItem(STORAGE_INSTITUTION)
}

export const removeSelectedInstitution = () => {
  localStorage.removeItem(STORAGE_SELECTED_INSTITUTION)
}
